<template>
  <span class="text-xl text-nowrap font-bold">
    Freqtrade<span class="text-primary font-bold">UI</span></span
  >
</template>
